import PropTypes from "prop-types"
import React from "react"
import Section from "components/Layout/Section"
import SimpleHeader from "components/Layout/SimpleHeader"
import * as css from "./MultiComparisonTable.module.css"

function MultiComparisonTable({
  label,
  heading,
  description,
  competitors = [],
  rows,
}) {
  return (
    <Section padding="light">
      <SimpleHeader
        label={label}
        title={heading}
        subtitle={description}
        dash="vertical"
        narrow="both"
      />
      <div className={css.tableWrapper}>
        <table className={css.table}>
          <thead>
            <tr>
              <th className={css.featureHeader}>Feature</th>
              <th className={css.presetHeader}>Preset</th>
              {competitors.map((competitor, idx) => {
                const name =
                  typeof competitor === "string" ? competitor : competitor.name
                const url =
                  typeof competitor === "string" ? null : competitor.url
                return (
                  <th key={idx} className={css.competitorHeader}>
                    {url ? <a href={url}>{name}</a> : name}
                  </th>
                )
              })}
            </tr>
          </thead>
          <tbody>
            {rows?.map((row, index) => (
              <tr key={index} className={css.row}>
                <td className={css.feature}>{row.feature}</td>
                <td className={css.presetCell}>
                  {row.preset === true ? (
                    <span className={css.check}>✓</span>
                  ) : row.preset === false ? (
                    <span className={css.x}>✗</span>
                  ) : (
                    <span className={css.note}>{row.preset}</span>
                  )}
                  {row.presetNote && (
                    <span className={css.cellNote}>{row.presetNote}</span>
                  )}
                </td>
                {competitors.map((_, idx) => {
                  const value = row.competitors?.[idx]
                  const note = row.competitorNotes?.[idx]
                  return (
                    <td key={idx} className={css.competitorCell}>
                      {value === true ? (
                        <span className={css.check}>✓</span>
                      ) : value === false ? (
                        <span className={css.x}>✗</span>
                      ) : (
                        <span className={css.note}>{value}</span>
                      )}
                      {note && <span className={css.cellNote}>{note}</span>}
                    </td>
                  )
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Section>
  )
}

MultiComparisonTable.propTypes = {
  label: PropTypes.string,
  heading: PropTypes.string,
  description: PropTypes.string,
  competitors: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({ name: PropTypes.string, url: PropTypes.string }),
    ])
  ),
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      feature: PropTypes.string.isRequired,
      preset: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
      presetNote: PropTypes.string,
      competitors: PropTypes.arrayOf(
        PropTypes.oneOfType([PropTypes.bool, PropTypes.string])
      ),
      competitorNotes: PropTypes.arrayOf(PropTypes.string),
    })
  ),
}

export default MultiComparisonTable
